import React, { useEffect, useState } from "react";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import { ErrorText } from "../CadastrarMedico/styles";
import { PageTitle} from "../Creditos/styles";
import { OptionTitle } from "../Creditos/styles";
import { PacientInfo } from "../PacienteUnico/styles";
import {
  Boxborda,
  Boxcentro,
  Boxpad,
  ConfirmBtn,
  SenhaInput,
} from "./styles";
import { useHistory} from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageContainer from "../../../Components/PageContainer";
import ReactLoading from "react-loading";

export default function RedefinicaoSenha() {
  const history = useHistory();
  const [senha, setSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");
  const [invalidFields, setInvalidFields] = useState(false);
  const [loadingNovaSenha, setLoadingNovaSenha] = useState(false);

  function handleSubmit() {
    console.log("Estou aqui");
    console.log(senha, confirmaSenha);
    if (senha.length < 8) {
      const showToastMessage = () => {
        toast.error(`Sua senha precisa conter no mínimo 8 caracteres!`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessage();
      return;
    } else {
      sendData();
    }
  }

  const sendData = async () => {
    setLoadingNovaSenha(true);
    try {
      const data = {
        senha: senha,
      };
      const response = await api.patch(`/auth/atualizar-senha`, data);
      const showToastMessage = () => {
        toast.success(`Senha redefinida com sucesso!`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessage();
      history.goBack();
    } catch (error) {
      console.log(error);
      const showToastMessage = () => {
        toast.error(
          `Ocorreu um erro ao tentar redefinir sua senha. Tente novamente!`,
          {
            position: toast.POSITION.TOP_CENTER,
          }
        );
      };
      showToastMessage();
    }
    setLoadingNovaSenha(false);
  };

  useEffect(() => {
    if (!senha || !confirmaSenha || senha !== confirmaSenha) {
      setInvalidFields(true);
    } else {
      setInvalidFields(false);
    }
  }, [senha, confirmaSenha]);

  return (
    <Page>
      <SidebarMenu />
      <PageContainer>
        <PageTitle>Redefinir senha</PageTitle>
        <PacientInfo>
          <Boxborda>
            <Boxcentro>
              <Boxpad pad={1}>
                <OptionTitle>Digite a senha</OptionTitle>
              </Boxpad>
              <Boxpad pad={4}>
                <SenhaInput
                  onChange={(event) => setSenha(event.target.value)}
                  placeholder=" Digite a senha"
                  type="password"
                ></SenhaInput>
              </Boxpad>
              <Boxpad pad={1}>
                <OptionTitle>Confirme a senha</OptionTitle>
              </Boxpad>
              <Boxpad pad={6}>
                <SenhaInput
                  onChange={(event) => setConfirmaSenha(event.target.value)}
                  placeholder=" Digite a senha"
                  type="password"
                ></SenhaInput>
                {(invalidFields && senha) && <ErrorText>Senhas não conferem</ErrorText>}
              </Boxpad>
              <ConfirmBtn
                onClick={(event) => handleSubmit(event.target.value)}
                disabled={invalidFields || loadingNovaSenha}
              >
                {loadingNovaSenha ? (
                  <ReactLoading type="spin" color="#B2EBF2" height={"20px"} width={"20px"} />
                ) : (
                  "Redefinir Senha"
                )}
              </ConfirmBtn>
            </Boxcentro>
          </Boxborda>
        </PacientInfo>
      </PageContainer>
    </Page>
  );
}
